<template>
		<div class="course-list">
			<div v-if="showIframe">
				<div class="back" @click="goBack">返回</div>
			  <iframe allow="camera; microphone; geolocation; fullscreen; clipboard-read; clipboard-write; accelerometer; gyroscope; payment; display-capture; autoplay" :src="iframeSrc" style="width: 100%; height: calc(100vh - 4rem); border: none;"></iframe>
			</div>
			<div v-if="!showIframe" class="sub-head">
				<div class="course-title">AI工具</div>
			</div>	
			<div v-if="!showIframe" class="course-cont">
				<div class="course-card" :style="{backgroundImage:`url(${item.bg})`}" v-for="(item,index) in courseList" @click="goQftx(item.link)" :key="index"></div>
			</div>
		</div>
</template>
<script>

export default {
	name: 'index',

	components: {},

	data(){
		return {
			actTab:1,
			showIframe: false,
			iframeSrc: '',
			userInfo:JSON.parse(localStorage.getItem('userInfo')),
			courseList:[
				{
					bg:require('../assets/shuxue.png'),
					link:'https://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=359'+'&user_id='+JSON.parse(localStorage.getItem('userInfo')).qfUserId+'&token='+JSON.parse(localStorage.getItem('userInfo')).qfToken
				},
				{
					bg:require('../assets/yingyu.png'),
					link:'https://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=219'+'&user_id='+JSON.parse(localStorage.getItem('userInfo')).qfUserId+'&token='+JSON.parse(localStorage.getItem('userInfo')).qfToken
				},
				{
					bg:require('../assets/wuli.png'),
					link:'https://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=360'+'&user_id='+JSON.parse(localStorage.getItem('userInfo')).qfUserId+'&token='+JSON.parse(localStorage.getItem('userInfo')).qfToken
				},
				{
					bg:require('../assets/huaxue.png'),
					link:'https://readapi.bluebirdabc.com/lessonplayer/index.html?pid=w7398uoaiIAF98wu&lessonId=361'+'&user_id='+JSON.parse(localStorage.getItem('userInfo')).qfUserId+'&token='+JSON.parse(localStorage.getItem('userInfo')).qfToken
				},
				{
					bg:require('../assets/yffx.png'),
					link:'https://read2.bluebirdabc.com/photo?pid=w7398uoaiIAF98wu'+'&user_id='+JSON.parse(localStorage.getItem('userInfo')).qfUserId+'&token='+JSON.parse(localStorage.getItem('userInfo')).qfToken
				},
				{
					bg:require('../assets/znyd.png'),
					link:'https://read2.bluebirdabc.com/index?pid=w7398uoaiIAF98wu'+'&user_id='+JSON.parse(localStorage.getItem('userInfo')).qfUserId+'&token='+JSON.parse(localStorage.getItem('userInfo')).qfToken
				}
			],
		}
	},

	created(){

	},
	mounted() {
	    this.$eventBus.$on('initPage', this.goBack);
	},
	beforeDestroy() {
	    this.$eventBus.$off('initPage', this.goBack);
	},

	computed: {

	},
	watch: {

	},
	methods: {
		goQftx(link){
			let msg = this.setTab();
			if(msg){
				this.$message.warning(msg);
				return;
			}
			this.showIframe = true;
			this.iframeSrc = link;
		},
		goBack(){
			this.showIframe = false;
			this.iframeSrc = '';
		},
		setTab(){
			if(!this.userInfo.authIds){
				return '授权时间已过，请联系相关老师开通新的授权1。'
			}
			return false
		}
	}
}
</script>

<style lang="scss" scoped>
.course-list{
	padding: 1.5rem 0 5rem 0.75rem;
	.sub-head{
		margin-bottom: 1.25rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-left: 0.75rem;
		.course-title{
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-weight: 500;
			font-size: 1.6rem;
			color: #000000;
			line-height: 1.7rem;
		}
		.course-more{
			display: flex;
			align-items: center;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.2rem;
			color: rgba(0,0,0,0.8);
			line-height: 1.41rem;
			img{
				width: 1.4rem;
				height: 1.4rem;
			}
		}
		.subject{
			display: flex;
			font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
			font-size: 1.4rem;
			color: #000000;
			line-height: 1.64rem;
			margin-right: 1.5rem;
			.tab{
				width: 5.5rem;
				height: 2.5rem;
				line-height: 2.5rem;
				text-align: center;
				border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
				margin-left: 5.8rem;
			}
			.actTab{
				background: rgb(100, 45, 113);
				color: #fff;
			}
		}
	}
	.course-cont{
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		.course-card{
			width: 18.35rem;
			height: 14.45rem;
			border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
			margin: 0.7rem;
			background-repeat: no-repeat;
			background-size: contain;
		}
	}
}
.back{
	text-align: center;
	width: 4rem;
	height: 4rem;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 100%;
	font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
	font-weight: 500;
	font-size: 1.6rem;
	line-height: 1.88rem;
	position: absolute;
	bottom: 5rem;
	left: 2rem;
	z-index: 999;
	color: #FFFFFF;
	background: rgb(100, 45, 113);
	border: 0.2rem solid #E0E0E0;
}
</style>
